namespace $.$$ {
	export class $shm_hitalama_map_settings extends $.$shm_hitalama_map_settings {

		map_catalog(): $shm_hitalama_map_catalog {
			return this.$.$shm_hitalama_app.Root( 0 ).Maps() as $shm_hitalama_map_catalog
		}

		map_favorite( next?: boolean ) {
			return this.map_catalog().map_favorite( this.map().link().toString(), next )
		}

		favorite_title() {
			return this.map_favorite() ? 'Убрать из избранного' : 'Добавить в избранное'
		}

		@ $mol_mem
		description( next?: string ): string {
			return this.map().Description(next)?.val( next ) ?? ''
		}
		
		@ $mol_mem
		exported_file_name() {
			return this.map().title() + '.json'
		}

		@ $shm_hitalama_process_wire_action
		map_serialize() {
			return this.map().serialized()
		}

		@ $shm_hitalama_process_wire_action
		map_serialize_without_files() {
			return this.map().serialize_without_files()
		}

		@ $mol_mem
		exported_json() {
			const obj = this.map_serialize()
			const data_uri = "data:text/json;charset=utf-8," + encodeURIComponent( JSON.stringify( obj, null, '\t' ) )
			return data_uri
		}

		@ $mol_mem
		exported_without_files_file_name() {
			return this.map().title() + '.no-files.json'
		}

		@ $mol_mem
		exported_without_files_json() {
			const obj = this.map_serialize_without_files()
			const data_uri = "data:text/json;charset=utf-8," + encodeURIComponent( JSON.stringify( obj, null, '\t' ) )
			return data_uri
		}

		@ $mol_action
		restore_file( files: File[] ) {
			const json = $mol_wire_sync(this.$).$mol_blob_json( files[0] )
			this.map().deserialize( json )
		}
		
		@ $mol_mem
		scale_percent() {
			return (this.zoom() * 100).toFixed(2) + '%'
		}

		@ $mol_action
		reset_scale() {
			this.zoom( 1 )
			this.shift( new $mol_vector_2d( 0, 0 ) )
		}

		@ $mol_mem
		widget_list_visible( next?: boolean ) {
			if( next ) this.file_list_visible( false )
			return this.$.$mol_state_local.value( this.toString() + 'widget_list_visible', next ) ?? false
		}

		@ $mol_mem
		rights_visible( next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem
		file_list_visible( next?: boolean ) {
			if( next ) this.widget_list_visible( false )
			return this.$.$mol_state_local.value( this.toString() + 'file_list_visible', next ) ?? false
		}

		@ $mol_mem
		widget_props_visible( next?: boolean ) {
			return this.$.$mol_state_local.value( this.toString() + 'widget_props_visible', next ) ?? false
		}

		@ $mol_mem
		widget_headers_visible( next?: boolean ) {
			return this.$.$mol_state_local.value( this.toString() + 'widget_headers_visible', next ) ?? false
		}

		@ $mol_mem
		arrows_visible( next?: boolean ) {
			return this.$.$mol_state_local.value( this.toString() + 'arrows_visible', next ) ?? true
		}

		@ $mol_mem
		editor_mode_enabled( next?: boolean ) {
			if( next === undefined ) return this.$.$mol_state_arg.value( 'edit_mode') != null
			if( next ) {
				this.$.$mol_state_arg.value( 'edit_mode', '' )
			} else {
				this.$.$mol_state_arg.value( 'edit_mode', null )
				this.$.$mol_state_arg.value( 'edit_widget', null )
			}
			return next
		}

	}
}
